import {SimpleUserInfo} from './simple-user-info.model';

export class SachetAction {

    token: string;
    date: Date;
    dateTimestamp: number;
    counter: number;
    sachetType: string;
    actionType: string;
    patientType: string;
    malnutritionType: string;
    user: SimpleUserInfo;
    organization: string;
    organizationId: number;


    static mockDecreaseAction(count: number, sachetType: string): SachetAction {
        const action = new SachetAction();
        action.date = new Date();
        action.counter = count;
        if ('red' === sachetType) {
            action.sachetType = 'Rojo (500kcal)';
        } else {
            action.sachetType = 'Amarillo (270kcal)';
        }
        action.actionType = 'Sobres distribuidos';
        action.patientType = 'Niño';
        action.malnutritionType = 'Desnutrición aguda severa';
        action.user = new SimpleUserInfo('xpto', 'juan.perez@gmail.com', 'Juan Perez');
        return action;
    }

    static mockAddictionAction(count: number, sachetType: string): SachetAction {
        const action = new SachetAction();
        action.date = new Date();
        action.counter = count;
        if ('red' === sachetType) {
            action.sachetType = 'Rojo (500kcal)';
        } else {
            action.sachetType = 'Amarillo (270kcal)';
        }
        action.sachetType = 'Sobres agregados al inventario';
        action.patientType = 'Niño';
        action.malnutritionType = 'Desnutrición aguda severa';
        action.user = new SimpleUserInfo('xpto', 'juan.perez@gmail.com', 'Juan Perez');
        return action;
    }

    static mockDecreaseActionForWoman(count: number, sachetType: string): SachetAction {
        const action = new SachetAction();
        action.date = new Date();
        action.counter = count;
        if ('red' === sachetType) {
            action.sachetType = 'Rojo (500kcal)';
        } else {
            action.sachetType = 'Amarillo (270kcal)';
        }
        action.actionType = 'Sobres distribuidos';
        action.patientType = 'Mujer';
        action.malnutritionType = 'Desnutrición aguda severa';
        action.user = new SimpleUserInfo('xpty', 'carlos.menezes@gmail.com', 'Carlos Menezes');
        return action;
    }


}
